var render = function (_h,_vm) {
var _obj;
var _c=_vm._c;return _c('v-form',{attrs:{"value":_vm.valid},on:{"submit":function($event){$event.preventDefault();return (function (e) { return (_vm.listeners.submit ? _vm.listeners.submit(e) : false); })($event)},"input":function (v) { return _vm.listeners.validation && _vm.listeners.validation(v); }}},[_c('v-container',{staticClass:"pt-6 pb-3",class:Object.assign({
      'px-5': true
    },
      _vm.data.class,
      ( _obj = {}, _obj[_vm.data.staticClass] = !!_vm.data.staticClass, _obj ))},[_c('v-row',_vm._l((_vm.props.fields),function(field){
    var _obj;
return _c('v-col',{directives:[{name:"show",rawName:"v-show",value:(!field.hidden),expression:"!field.hidden"}],key:field.name,class:( _obj = {
          'py-2': true
        }, _obj[_vm.props.flexClass] = !field.flexClass && !!_vm.props.flexClass, _obj[field.flexClass] = !!field.flexClass, _obj )},[_c('field-printer',{attrs:{"field":field,"fieldError":_vm.props.fieldsErrors[field.name],"value":_vm.props.values[field.name]},on:{"input":function (v) {
                  var _obj;

                  return _vm.listeners.input(
                field.inputHandler ? field.inputHandler(v, _vm.props.values) : Object.assign({}, _vm.props.values, ( _obj = {}, _obj[field.name] = v, _obj ))
              );
    }},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._t(field.type,null,{"field":props.field,"value":props.value,"listeners":props.listeners})]}}],null,true)})],1)}),1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }